import React from "react";

const RestrictionPanel = () => {
  return <>
    <h1>利用規約</h1>
    <p>
      この度は名刺Rをご利用いただきありがとうございます。
    </p>
    <p>
      <span
        style={{fontWeight: 'bold'}}>ご利用者様は、株式会社カード･アンド･メディア（以下「弊社」といいます）の運営する名刺のWEB化ツール「名刺R」を以下の規約によりご利用いただくことになりますので、予めご了承ください。</span>
    </p>
    <p>
      (1)
      名刺Rはご利用の皆様にWEB上でQRを使った名刺の使用が出来るようになり離れた方との名刺の交換が可能にするプラットホームを作成、提供しています。名刺Rの内容は、事前に予告することなく、変更、修正することがあります。弊社はこれらについて、何ら責任を負うものではありません。
    </p>
    <p>
      (2) 登録されている名刺の内容は登録した本人によるもので、その内容により生じたいかなる損害に関しても弊社は責任を負いません。<br/>
      また、名刺Rに掲載している情報の正確性に万全を期しておりますが、技術上または法令解釈上など不正確な記載や誤植を含む場合があります。情報が不性格であったこと、あるいは誤植があったことなどにより生じたいかなる損害に関しても弊社は責任を負いません。
    </p>
    <p>
      (3) インターネットシステムの中断<br/>
      〇本システムの保守点検・更新を定期的に、または緊急に行う場合<br/>
      〇天災、火災、停電などの不可抗力により本システムの運営が困難な場合<br/>
      〇その他運用上、技術上やむを得ない事情で一時中断する必要が生じた場合では、弊社はお客様に事前に通知することなく、一時的にシステムの使用を中断する場合があります。
    </p>
    <p>
      (4)
      公序良俗に反する又は反社会的勢力と認められる内容のアップロードにつきましては、ご利用を控えさせて頂いております。ご登録後でも弊社で確認が取れました場合には、事前の連絡なくご登録をキャンセルさせて頂きますので、ご了承ください。
    </p>
    <p>
      (5) 個人情報の利用について<br/>
      弊社は、ご登録いただいた個人情報を業務の遂行に必要な限りにおいて利用し、目的の達成に必要な範囲を超えた個人情報の取扱い（目的外利用）は行いません。また、目的外利用を行わないための措置を講じます。<br/>
      個人情報の第三者提供について弊社は、法令に定める場合を除き、個人情報を、事前に本人の同意を得ることなく、第三者に提供いたしません。
    </p>
  </>
}

export default RestrictionPanel
